import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import Carousel from './Carousel';

// Import Perati screenshots
import perati1 from '../assets/images/perati/Screenshot at Jan 06 14-59-48.png';
import perati2 from '../assets/images/perati/Screenshot at Jan 06 15-07-48.png';
import perati3 from '../assets/images/perati/Screenshot at Jan 06 15-08-14.png';

// Import Soti Bakery screenshots
import sotiBakeryLogin from '../assets/images/soti-bakery/www.soti-bakery.com_admin_login(iPad Air).png';
import sotiBakery1 from '../assets/images/soti-bakery/1.png';
import sotiBakery2 from '../assets/images/soti-bakery/2.png';
import sotiBakery3 from '../assets/images/soti-bakery/3.png';
import sotiBakery4 from '../assets/images/soti-bakery/4.png';
import sotiBakery5 from '../assets/images/soti-bakery/5.png';
import sotiBakery6 from '../assets/images/soti-bakery/6.png';
import sotiBakery7 from '../assets/images/soti-bakery/7.png';
import sotiBakery8 from '../assets/images/soti-bakery/8.png';
import sotiBakery9 from '../assets/images/soti-bakery/9.png';
import sotiBakery10 from '../assets/images/soti-bakery/10.png';
import sotiBakery11 from '../assets/images/soti-bakery/11.png';

// Import Paypayan screenshots
import paypayan0 from '../assets/images/paypayan/0.png';
import paypayan1 from '../assets/images/paypayan/1.jpeg';
import paypayan2 from '../assets/images/paypayan/2.jpeg';
import paypayan3 from '../assets/images/paypayan/3.jpeg';
import paypayan4 from '../assets/images/paypayan/4.jpeg';
import paypayan5 from '../assets/images/paypayan/5.jpeg';
import paypayan6 from '../assets/images/paypayan/6.jpeg';
import paypayan7 from '../assets/images/paypayan/7.jpeg';

// Import Flutter Portfolio screenshots
import flutter1 from '../assets/images/flutterportfolio/Simulator Screenshot - iPhone 16 Plus - 2025-05-12 at 01.31.20.png';
import flutter2 from '../assets/images/flutterportfolio/Simulator Screenshot - iPhone 16 Plus - 2025-05-12 at 01.31.40.png';
import flutter3 from '../assets/images/flutterportfolio/Simulator Screenshot - iPhone 16 Plus - 2025-05-12 at 01.31.46.png';

// Import company logos
import peratiLogo from '../assets/images/Perati.jpg';
import zeroOneLogo from '../assets/images/zeroone-it-solutions-logo.jpg';

const Projects = () => {
    const [logoErrors, setLogoErrors] = React.useState({});

    const handleLogoError = (projectId) => {
        setLogoErrors(prev => ({ ...prev, [projectId]: true }));
    };

    const projects = [
        {
            id: 1,
            title: 'Paypayan POS System',
            logo: zeroOneLogo,
            date: '2024 — 2025',
            description: 'Developed and deployed a custom POS system for Paypayan, a food store offering inasal, coffee, frappe, noodles, and other menu items. Built workflows for fast order processing, inventory monitoring, and sales tracking. Includes role-based access with separate Super Admin, Admin, and Cashier logins for controlled operations. Demo access available upon request.',
            achievements: [
                'Multi-tenant database architecture with customer data isolation',
                'Configurable warehouse system for unlimited branch scalability',
                'Real-time Socket.io notification engine',
                'Transaction-level database locking for data integrity',
                'JWT-based role-based authorization middleware',
                'Currently deployed serving multiple production customers'
            ],
            technologies: ['React 19', 'Redux', 'Node.js', 'Express.js', 'MySQL', 'Sequelize ORM', 'Socket.io', 'JWT', 'Tailwind CSS', 'Multi-tenant Architecture', 'RBAC', 'REST API'],
            links: [],
            images: [paypayan0, paypayan1, paypayan2, paypayan3, paypayan4, paypayan5, paypayan6, paypayan7],
            featured: true
        },
        {
            id: 2,
            title: 'Soti Bakery & Convenience POS Deployment',
            logo: zeroOneLogo,
            date: '2026',
            description: 'Launched the POS system for a local bakery and convenience store. Trained staff to use it for daily operations, including order processing, inventory tracking, and sales reporting. Includes role-based access with separate Super Admin, Admin, and Cashier logins for controlled operations. Demo access available upon request.',
            achievements: [
                'Deployed POS in a live bakery and convenience store environment',
                'Delivered staff onboarding and operational workflow training',
                'Improved day-to-day visibility for inventory and sales performance',
                'Maintained stable operations with minimal downtime'
            ],
            technologies: ['React 19', 'Redux', 'Node.js', 'Express.js', 'MySQL', 'Sequelize ORM', 'Socket.io', 'JWT', 'Role-based Access Control', 'Real-time Updates', 'Multi-tenant Architecture', 'REST API', 'Production Deployment', 'Git'],
            links: [],
            images: [sotiBakeryLogin, sotiBakery1, sotiBakery2, sotiBakery3, sotiBakery4, sotiBakery5, sotiBakery6, sotiBakery7, sotiBakery8, sotiBakery9, sotiBakery10, sotiBakery11],
            featured: false
        },
        {
            id: 3,
            title: 'PERATI',
            logo: peratiLogo,
            date: '2023',
            description: 'Built the frontend mobile app in Flutter for PERATI, a fleet management solution. Implemented core UI workflows for real-time operational updates and day-to-day monitoring tasks. Focused on reliable state management, smooth UX, and clean API consumption in poor-network conditions.',
            achievements: [
                'Built frontend modules for fleet and trip status tracking',
                'Implemented real-time UI synchronization for operational updates',
                'Developed role-based frontend workflows for daily monitoring tasks',
                'Optimized for low-bandwidth and poor connectivity environments',
                'Engineered smooth state management for consistent app behavior',
                'Collaborated with backend team for API contracts, integration, and fixes'
            ],
            technologies: ['Flutter', 'Dart', 'Provider', 'HTTP Client', 'REST APIs', 'State Management', 'Material Design', 'iOS', 'Android'],
            links: [
                { label: 'perati.org', url: 'https://www.perati.org/' }
            ],
            images: [perati1, perati2, perati3],
            featured: false
        },
        {
            id: 4,
            title: 'Mobile Portfolio App',
            date: '2025',
            description: 'Built a mobile portfolio app with Flutter to showcase projects, skills, and experience. Designed for touch-first interaction with smooth animations and responsive layouts across screen sizes.',
            achievements: [
                'Built cross-platform mobile app with Flutter',
                'Designed mobile-first UI with smooth animations',
                'Implemented swipe gestures and touch interactions',
                'Created responsive layouts for different screen sizes',
                'Optimized for both iOS and Android platforms'
            ],
            technologies: ['Flutter', 'Dart', 'Material Design', 'Animations', 'Gesture Detection', 'State Management', 'iOS', 'Android'],
            links: [],
            images: [flutter1, flutter2, flutter3],
            featured: false
        },
        // {
        //     id: 5,
        //     title: 'Espressoule',
        //     date: '2026',
        //     description: 'Created a countdown website for my coffee shop concept to build early audience interest. The "Coming Soon" page focuses on clean branding, modern visuals, and launch anticipation.',
        //     technologies: ['HTML', 'CSS', 'JavaScript'],
        //     links: [
        //         { label: 'Visit Site', url: 'https://espressoule.ownerxyz.site/' }
        //     ],
        //     images: [espressoule1],
        //     featured: false
        // }
    ];

    return (
        <section id="projects" className="section" aria-labelledby="projects-heading">
            <h2 id="projects-heading" className="section-title">Projects</h2>
            <div className="section-content">
                {projects.map((project) => (
                    <div key={project.id} className={`project-item ${project.featured ? 'featured' : ''}`}>
                        {project.featured && <div className="featured-badge">Featured</div>}
                        <div className="project-date">{project.date}</div>
                        <div className="project-content">
                            <h3 className="project-title">
                                {project.logo && !logoErrors[project.id] && (
                                    <img
                                        src={project.logo}
                                        alt={`${project.title} logo`}
                                        className="project-logo"
                                        onError={() => handleLogoError(project.id)}
                                        loading="lazy"
                                    />
                                )}
                                {project.title}
                            </h3>
                            {project.links && project.links.length > 0 && (
                                <div className="project-links">
                                    {project.links.map((link, index) => (
                                        <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" title={link.label}>
                                            {link.label} <FaExternalLinkAlt style={{ fontSize: '0.75rem', marginLeft: '4px' }} />
                                        </a>
                                    ))}
                                </div>
                            )}

                            <p className="project-description">{project.description}</p>

                            {project.achievements && project.achievements.length > 0 && (
                                <ul className="project-achievements">
                                    {project.achievements.map((achievement, index) => (
                                        <li key={index}>{achievement}</li>
                                    ))}
                                </ul>
                            )}
                            <div className="tech-list">
                                {project.technologies.map((tech, index) => (
                                    <span key={index} className="tech-item">
                                        {tech}
                                    </span>
                                ))}
                            </div>

                            {/* Display carousel at the bottom for a complete visual showcase */}
                            {project.images && project.images.length > 0 && (
                                <div className={project.title === 'Mobile Portfolio App' ? 'mobile-carousel-wrapper' : ''}>
                                    <Carousel images={project.images} alt={project.title} />
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Projects;
